import { GameBase } from '../../shared/models/game-base';
import type { ITeam } from '../../shared/interfaces/ITeam';
import { SelectionType } from '../../shared/enums/selection-type';

/**
 * NBA Game.
 * - No TIE logic (TeamThatWon/TeamThatLost/GameClass match base but only AWAY_WIN/HOME_WIN).
 * - SortOrder is simple epoch-based (base default) — just reads gameDate epoch.
 * - gameKey is a string identifier.
 */
export class NbaGame extends GameBase {
  constructor(
    home: KnockoutObservable<ITeam> | ITeam,
    away: KnockoutObservable<ITeam> | ITeam,
    week: number,
    gameScheduleNum?: number,
    primeTimeType?: number,
    gameDate?: string,
    gameGuid?: string,
    gameKey?: string
  ) {
    super({
      home: home as KnockoutObservable<ITeam>,
      away: away as KnockoutObservable<ITeam>,
      week,
      gameScheduleNum,
      primeTimeNum: primeTimeType,
      gameDate,
      gameGuid,
      gameKey,
    });
  }

  /** NBA has no TIE; only AWAY_WIN/HOME_WIN count. */
  protected override createGameClass(): string {
    const self = this;
    let retStr = '';
    if (self.selectionMade() && self.TeamThatWon()) {
      retStr += 'selection-made ';
      if (self.selectionType() !== SelectionType.NONE) {
        retStr += self.TeamThatWon()().TeamAbbreviation;
      }
    }
    return retStr;
  }

  protected override createTeamThatWon(): KnockoutObservable<ITeam> | null {
    const self = this;
    if (self.selectionMade() && self.selectionType() !== SelectionType.NONE) {
      switch (self.selectionType()) {
        case SelectionType.AWAY_WIN:
          return self.away;
        case SelectionType.HOME_WIN:
          return self.home;
        default:
          return null;
      }
    }
    return null;
  }

  protected override createTeamThatLost(): KnockoutObservable<ITeam> | null {
    const self = this;
    if (self.selectionMade() && self.selectionType() !== SelectionType.NONE) {
      switch (self.selectionType()) {
        case SelectionType.AWAY_WIN:
          return self.home;
        case SelectionType.HOME_WIN:
          return self.away;
        default:
          return null;
      }
    }
    return null;
  }

  // SortOrder: epoch-based (base default handles gameDate → parseInt epoch).
  // No override needed — WeekBase/GameBase base default is epoch or 1 fallback.
}
